/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../utils/formatting';

const GreeceTaxExemptInfo = ({ customers, totals }) => {
  const {
    locale: { storeCurrency, storeLocale }, RL_Name, RL_City, RL_State, RL_PostalCode, RL_TaxExemptNo
  } = useSelector((state) => state);

  const FullName = customers?.[0]?.Name?.FullName;
  const { City, StateOrProvince, PostalCode } = customers?.[0]?.Addresses?.[0] || {};
  const taxExemptNo = customers?.[0]?.TaxCertificates?.[0]?.Number;

  const transactionSubtotal = totals?.find((total) => total?.TotalType === 'TransactionSubtotal')?.Amount;

  return (
    <>
      <section>
        <article className="justify-between">
          <p>Καθαρή αξία</p>
          <p>{transactionSubtotal && currencyFormatter(storeLocale, storeCurrency, transactionSubtotal)}</p>
        </article>
        {FullName && (
          <article className="justify-between align-left">
            <p className="pl2-sm">{RL_Name}: {FullName}</p>
          </article>
        )}
        {City && (
          <article className="justify-between align-left">
            <p className="pl2-sm">{RL_City}: {City}</p>
          </article>
        )}
        {StateOrProvince && (
          <article className="justify-between align-left">
            <p className="pl2-sm">{RL_State}: {StateOrProvince}</p>
          </article>
        )}
        {PostalCode && (
          <article className="justify-between align-left">
            <p className="pl2-sm">{RL_PostalCode}: {PostalCode}</p>
          </article>
        )}
        {taxExemptNo && (
          <article className="justify-between align-left">
            <p className="pl2-sm">{RL_TaxExemptNo}: {taxExemptNo}</p>
          </article>
        )}
      </section>
    </>
  );
};

GreeceTaxExemptInfo.defaultProps = {
  customers: [],
};

GreeceTaxExemptInfo.propTypes = {
  customers: PropTypes.arrayOf(PropTypes.shape()),
  totals: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default GreeceTaxExemptInfo;
